<template>
  <div class="content">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-12 px-0">
          <top-navbar :title="restaurantName" search="false"></top-navbar>
        </div>
        <div class="col-md-10 offset-md-1 col-12 text-center" style="margin-top: 2rem">
          <div class="row">
            <div v-if="userRole == 'Admin'" class="col-md-4 col-12 px-0">
              <sidebar-link to="/admin/create-owner?edit=true" class="restaurantBox">
                <img src="/img/business-details.png" alt="Logo">
                <h4 class="text-white">Business & Owner Details</h4>
              </sidebar-link>
            </div>
            <div class="col-md-4 col-12 px-0">
              <sidebar-link to="/admin/menu-management" class="restaurantBox">
                <img src="/img/menu-entry.png" alt="Logo">
                <h4 class="text-white">Menu Entry</h4>
              </sidebar-link>
            </div>
            <div v-if="userRole == 'Admin'" class="col-md-4 col-12 px-0">
              <sidebar-link to="/admin/content-management" class="restaurantBox">
                <img src="/img/website-update.png" alt="Logo">
                <h4 class="text-white">Website Update</h4>
              </sidebar-link>
            </div>
            <div v-if="userRole == 'Admin'" class="col-md-4 col-12 px-0">
              <sidebar-link to="/admin/content-management-v2" class="restaurantBox">
                <img src="/img/website-update.png" alt="Logo">
                <h4 class="text-white">Website Update V2</h4>
              </sidebar-link>
            </div>
            <div v-if="userRole == 'Admin'" class="col-md-4 col-12 px-0">
              <sidebar-link to="/admin/booking-list" class="restaurantBox">
                <img src="/img/website-update.png" alt="Logo">
                <h4 class="text-white">Booking List</h4>
              </sidebar-link>
            </div>
            <div v-if="userRole == 'Admin'" class="col-md-4 col-12 px-0">
              <sidebar-link to="/admin/customer-list" class="restaurantBox">
                <i style="color: #fff; font-size: 2.7rem;" class="nc-icon nc-single-02"></i>
                <h4 class="text-white">Customer List</h4>
              </sidebar-link>
            </div>
            <div v-if="userRole == 'Admin'" class="col-md-4 col-12 px-0">
              <sidebar-link to="/admin/best-sells" class="restaurantBox">
                <i style="color: #fff; font-size: 2.7rem;" class="nc-icon nc-album-2"></i>
                <h4 class="text-white">Best Sells</h4>
              </sidebar-link>
            </div>
            <div v-if="userRole == 'Admin'" class="col-md-4 col-12 px-0">
              <div @click="toggleRposStatus" class="toggle-container mx-auto" id="toggleBtn">
                <span class="toggle-text">{{ rposStatus == 'Yes' ? 'ON' : 'OFF' }}</span>
                <div class="toggle-switch"></div>
              </div>
            </div>
            <div v-if="userRole == 'Admin'" class="col-md-4 col-12 px-0">
              <div @click="toggleBypassSignupEnable" class="signup-toggle-container mx-auto" id="signupToggleBtn">
                <span class="signup-toggle-text">{{ bypassSignupEnable == 'Yes' ? 'ON' : 'OFF' }}</span>
                <div class="signup-toggle-switch">Order <br> Bypass Signup</div>
              </div>
            </div>
            <div v-if="userRole == 'Admin'" class="col-md-4 col-12 px-0">
              <div @click="toggleBookingBypassSignupEnable" class="signup-toggle-container mx-auto" id="bookingSignupToggleBtn">
                <span class="signup-toggle-text">{{ bookingBypassSignupEnable == 'Yes' ? 'ON' : 'OFF' }}</span>
                <div class="signup-toggle-switch">Booking <br> Bypass Signup</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div v-if="userRole == 'Admin'" class="col-md-4 col-12 px-0">
              <div @click="togglePrinterType" class="printer-type-container mx-auto" id="printerTypeToggleBtn">
                <span class="printer-type-toggle-text">{{ printerType }}</span>
                <div class="printer-type-toggle-switch">Printer <br> Type</div>
              </div>
            </div>
            <div v-if="userRole == 'Admin'" class="col-md-4 col-12 px-0">
              <div @click="toggleThirdPrinter" class="third-printer-toggle-container mx-auto" id="thirdPrinterToggleBtn">
                <span class="third-printer-toggle-text">{{ thirdPrinter == 'Active' ? 'Active' : 'Inactive' }}</span>
                <div class="third-printer-toggle-switch">Third <br> Printer</div>
              </div>
            </div>
            <div v-if="userRole == 'Admin'" class="col-md-4 col-12 px-0">
              <div @click="toggleWebsiteStatus" class="website-toggle-container mx-auto" id="websiteToggleBtn">
                <span class="website-toggle-text">{{ websiteStatus == 'Yes' ? 'ONLINE' : 'OFFLINE' }}</span>
                <div class="website-toggle-switch">GO</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-12 px-0"></div>
            <div class="col-md-4 text-center">
              <sidebar-link to="/admin/owner-list" class="backBtn">
                <img src="/img/arrow-left.png" alt="Logo">
              </sidebar-link>
            </div>
            <div class="col-md-4 col-12 px-0"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapMutations } from 'vuex'
  import TopNavbar from '../../layout/TopNavbar'
  import axios from 'axios'

  export default {
    components: {
      TopNavbar
    },
    data () {
      return {
        ownerMgmt: false,
        isMenuManagement: false,
        restaurantName: localStorage.getItem('restaurantName'),
        userRole: this.$cookies.get('adminData').role,
        webData: '',
        webConfig: '',
        rposStatus: '',
        bypassSignupEnable: '',
        bookingBypassSignupEnable: '',
        websiteStatus: '',
        thirdPrinter: '',
        printerType: '',
      }
    },
    mounted() {
      localStorage.removeItem('active_sidebar_el')
      this.getRestaurantData()
      this.getWebconfig()
    },
    methods: {
      ...mapMutations(['setRestaurantWebConfig', 'setRestaurantData']),

      getRestaurantData(){
        let url = process.env.VUE_APP_API_URL+'/api/restaurant/find?id='+localStorage.getItem('restaurantId')
        axios
          .get(url, {headers: {Authorization: `Bearer ${this.$cookies.get('token')}`}})
          .then((result) => {
            this.webData = result.data
            this.rposStatus = result.data.rposEnable
            this.thirdPrinter = typeof result.data.thirdPrinter == 'undefined' ? 'Inactive' : result.data.thirdPrinter
            this.printerType = typeof result.data.printerType == 'undefined' ? 'Sunmi' : result.data.printerType
            this.setRposToggleBtn()
            this.setThirdPrinterToggleBtn()
            this.setPrinterTypeToggleBtn()
            this.setRestaurantData(result.data)
          })
      },
      getWebconfig(){
        let url = process.env.VUE_APP_API_URL+'/api/webConfig?restaurantId='+localStorage.getItem('restaurantId')
        axios
          .get(url)
          .then((result) => {
            this.webConfig = result.data
            this.websiteStatus = result.data.goOnline
            this.bypassSignupEnable = result.data.bypassSignupEnable
            this.bookingBypassSignupEnable = result.data.bookingBypassSignupEnable
            this.setRestaurantWebConfig(result.data)
            this.setWebsiteToggleBtn()
            this.setByPassSignupToggleBtn()
            this.setBookingByPassSignupToggleBtn()
          })
      },
      ownerManagement () {
        this.ownerMgmt = !this.ownerMgmt
      },
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },
      toggleRposStatus(){
        this.rposStatus = this.rposStatus == 'Yes' ? 'No' : 'Yes'
        const url = process.env.VUE_APP_API_URL+'/api/restaurant/update'
        this.webData.rposEnable = this.rposStatus
        this.setRposToggleBtn()

        axios
        .post(url, this.webData, {headers: {Authorization: `Bearer ${this.$cookies.get('token')}`}})
        .then((data) => {
          if (data.status == 200) {
            this.$toastr.s(`rPos ${this.rposStatus == 'Yes' ? 'Enabled' : 'Disabled'}.`, "Success");
          }
        })
      },
      setRposToggleBtn(){
        const toggleBtn = document.getElementById("toggleBtn");
        const text = document.querySelector(".toggle-text");
        const toggleSwitch = document.querySelector(".toggle-switch");
        if(this.rposStatus == "Yes"){
          toggleBtn.classList.remove("inactive");
          text.style.transform = "translateX(0)";
          toggleSwitch.innerHTML = '<img src="/img/rpos-on.png" width="65%" height="100" alt="icon">';
        }else{
          toggleBtn.classList.add("inactive");
          text.style.transform = "translateX(150px)";
          toggleSwitch.innerHTML = '<img src="/img/rpos-off.png" width="65%" height="100" alt="icon">';
        }
      },
      toggleBypassSignupEnable(){
        this.bypassSignupEnable = this.bypassSignupEnable == 'Yes' ? 'No' : 'Yes'
        const url = process.env.VUE_APP_API_URL+'/api/webConfig/update'
        this.webConfig.bypassSignupEnable = this.bypassSignupEnable
        this.setByPassSignupToggleBtn()

        axios
        .post(url, this.webConfig, {headers: {Authorization: `Bearer ${this.$cookies.get('token')}`}})
        .then((data) => {
          if (data.status == 200) {
            this.$toastr.s(`Order Bypass Signup ${this.bypassSignupEnable == 'Yes' ? 'Enabled' : 'Disabled'}.`, "Success");
          }
        })
      },
      setByPassSignupToggleBtn(){
        const toggleBtn = document.getElementById("signupToggleBtn");
        const text = toggleBtn.querySelector(".signup-toggle-text");
        if(this.bypassSignupEnable == "Yes"){
          toggleBtn.classList.remove("inactive");
          text.style.transform = "translateX(0)";
        }else{
          toggleBtn.classList.add("inactive");
          text.style.transform = "translateX(150px)";
        }
      },
      toggleBookingBypassSignupEnable(){
        this.bookingBypassSignupEnable = this.bookingBypassSignupEnable == 'Yes' ? 'No' : 'Yes'
        const url = process.env.VUE_APP_API_URL+'/api/webConfig/update'
        this.webConfig.bookingBypassSignupEnable = this.bookingBypassSignupEnable
        this.setBookingByPassSignupToggleBtn()

        axios
        .post(url, this.webConfig, {headers: {Authorization: `Bearer ${this.$cookies.get('token')}`}})
        .then((data) => {
          if (data.status == 200) {
            this.$toastr.s(`Booking Bypass Signup ${this.bookingBypassSignupEnable == 'Yes' ? 'Enabled' : 'Disabled'}.`, "Success");
          }
        })
      },
      setBookingByPassSignupToggleBtn(){
        const toggleBtn = document.getElementById("bookingSignupToggleBtn");
        const text = toggleBtn.querySelector(".signup-toggle-text");
        if(this.bookingBypassSignupEnable == "Yes"){
          toggleBtn.classList.remove("inactive");
          text.style.transform = "translateX(0)";
        }else{
          toggleBtn.classList.add("inactive");
          text.style.transform = "translateX(150px)";
        }
      },
      toggleWebsiteStatus(){
        this.websiteStatus = this.websiteStatus == 'Yes' ? 'No' : 'Yes'
        const url = process.env.VUE_APP_API_URL+`/api/webConfig/updateGoOnline?restaurantId=${localStorage.getItem('restaurantId')}&isGoOnline=${this.websiteStatus}`
        this.setWebsiteToggleBtn()

        axios
        .get(url, {headers: {Authorization: `Bearer ${this.$cookies.get('token')}`}})
        .then((data) => {
          if (data.status == 200) {
            this.$toastr.s(`Website is now ${this.websiteStatus == 'Yes' ? 'Online' : 'Offline'}.`, "Success");
          }
        })
      },
      setWebsiteToggleBtn(){
        const toggleBtn = document.getElementById("websiteToggleBtn");
        const text = document.querySelector(".website-toggle-text");
        if(this.websiteStatus == "Yes"){
          toggleBtn.classList.remove("inactive");
          text.style.transform = "translateX(0)";
        }else{
          toggleBtn.classList.add("inactive");
          text.style.transform = "translateX(150px)";
        }
      },
      toggleThirdPrinter(){
        this.thirdPrinter = this.thirdPrinter == 'Active' ? 'Inactive' : 'Active'
        const url = process.env.VUE_APP_API_URL+'/api/restaurant/update'
        this.webData.thirdPrinter = this.thirdPrinter
        this.setThirdPrinterToggleBtn()

        axios
        .post(url, this.webData, {headers: {Authorization: `Bearer ${this.$cookies.get('token')}`}})
        .then((data) => {
          if (data.status == 200) {
            this.$toastr.s(`Third printer ${this.thirdPrinter}.`, "Success");
          }
        })
      },
      setThirdPrinterToggleBtn(){
        const toggleBtn = document.getElementById("thirdPrinterToggleBtn");
        const text = document.querySelector(".third-printer-toggle-text");
        if(this.thirdPrinter == "Active"){
          toggleBtn.classList.remove("inactive");
          text.style.transform = "translateX(0)";
        }else{
          toggleBtn.classList.add("inactive");
          text.style.transform = "translateX(150px)";
        }
      },
      togglePrinterType(){
        this.printerType = this.printerType == 'Sunmi' ? 'Other' : 'Sunmi'
        const url = process.env.VUE_APP_API_URL+'/api/restaurant/update'
        this.webData.printerType = this.printerType
        this.setPrinterTypeToggleBtn()

        axios
        .post(url, this.webData, {headers: {Authorization: `Bearer ${this.$cookies.get('token')}`}})
        .then((data) => {
          if (data.status == 200) {
            this.$toastr.s(`Printer type ${this.printerType}.`, "Success");
          }
        })
      },
      setPrinterTypeToggleBtn(){
        const toggleBtn = document.getElementById("printerTypeToggleBtn");
        const text = document.querySelector(".printer-type-toggle-text");
        if(this.printerType == "Sunmi"){
          toggleBtn.classList.remove("inactive");
          text.style.transform = "translateX(0)";
        }else{
          toggleBtn.classList.add("inactive");
          text.style.transform = "translateX(150px)";
        }
      },
    },
    watch: {
      $route (to, form) {
        if (to.name == 'MenuManagement' && to.path == '/admin/menu-management') {
          this.isMenuManagement = true
        }
        else {
          this.isMenuManagement = false
        }
      }
    }
  }

</script>
<style scoped>
  .restaurantBox{
    width: 315px;
    height: 150px;
    background: linear-gradient(179.48deg, #FD7902 36.9%, #FF0101 93.77%);
    border-radius: 10px;
    text-align: center;
    margin: 1rem;
    display: inline-grid;
  }
  .backBtn{
    width: 200px;
    height: 50px;
    background: linear-gradient(179.48deg, #7A7A7A 36.9%, #1C1C1C 93.77%);
    border-radius: 10px;
    text-align: center;
    margin: 3rem auto 0 auto;
    display: block;
  }
  .backBtn img{width: 40px; height: 30px;}
  .toggle-container,
  .signup-toggle-container,
  .website-toggle-container,
  .third-printer-toggle-container,
  .printer-type-container {
    position: relative;
    width: 315px;
    height: 150px;
    margin-top: 1rem;
    border-radius: 10px;
    box-shadow: -2px 3px 16px rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    padding: 0 !important;
    cursor: pointer;
    font-family: Arial, sans-serif;
    font-size: 14px;
    font-weight: bold;
    user-select: none;
    transition: background 0.3s ease-in-out;
    background-color: #078400;
  }
  .website-toggle-container, .third-printer-toggle-container, .printer-type-container{height: 70px; margin-top: 2rem;}
  .toggle-container.inactive{background: #F40000;}
  .signup-toggle-container.inactive,
  .website-toggle-container.inactive,
  .third-printer-toggle-container.inactive,
  .printer-type-container.inactive {
    background: linear-gradient(179.48deg, #FD7902 36.9%, #FF0101 93.77%);
  }
  .toggle-text, .signup-toggle-text, .website-toggle-text, .third-printer-toggle-text, .printer-type-toggle-text {
    width: 50%;
    height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    font-size: 40px;
    color: #fff;
    font-weight: bold;
    border-radius: 10px 0 0 10px;
  }
  .website-toggle-text, .third-printer-toggle-text, .printer-type-toggle-text{height: 70px; font-size: 25px;}
  .inactive .toggle-text,
  .inactive .signup-toggle-text,
  .inactive .website-toggle-text,
  .inactive .third-printer-toggle-text,
  .inactive .printer-type-toggle-text {
    border-radius: 0 10px 10px 0;
  }
  .toggle-switch, .signup-toggle-switch, .website-toggle-switch, .third-printer-toggle-switch, .printer-type-toggle-switch {
    position: absolute;
    right: 0px;
    width: 50%;
    height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    border-radius: 10px;
    transition: transform 0.3s ease-in-out;
  }
  .website-toggle-switch, .third-printer-toggle-switch, .printer-type-toggle-switch{height: 70px;}
  .inactive .toggle-switch,
  .inactive .signup-toggle-switch,
  .inactive .website-toggle-switch,
  .inactive .third-printer-toggle-switch,
  .inactive .printer-type-toggle-switch {
    transform: translateX(-158px);
  }
  .signup-toggle-switch, .website-toggle-switch, .third-printer-toggle-switch, .printer-type-toggle-switch {
    font-size: 1.5rem;
  }
</style>
